import React from 'react'
import PropTypes from 'prop-types'

import {
    Pagination,
    createTheme,
    ThemeProvider,
} from '@mui/material'

import './AppPagination.scss'

export default function AppPagination({
    currentPage = 1,
    pagination = {},
    onPageChange,
    showResultsText = true,
}) {
    const theme = createTheme({
        palette: {
            primary: { main: "#053F48" },
        },
    });

    const handlePageChange = (event, page) => {
        if (onPageChange) {
            onPageChange(page)
        }
    }
    
    return (
        <div className="apppagination">
            {showResultsText && (
                <div className="apppagination__results">
                    Showing {pagination?.from} - {pagination?.to} of {pagination?.total} results
                </div>
            )}
            <ThemeProvider theme={theme}>
                <Pagination
                    count={pagination?.last_page || 1}
                    shape="rounded"
                    page={Number(currentPage)}
                    onChange={handlePageChange}
                    color="primary"
                />
            </ThemeProvider>
        </div>
    )
}

AppPagination.propTypes = {
    currentPage: PropTypes.number,
    pagination: PropTypes.object,
    onPageChange: PropTypes.func,
    showResultsText: PropTypes.bool,
}
